import React, { Component } from "react";
class OutsideClickCheckHandler extends Component {
    constructor(props) {
        super(props);
        this.wrapperRef = null;
        this.classToCheck =
            "outside_click_check_handler_" + ++OutsideClickCheckHandler.counter;
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    setWrapperRef(node) {
        this.wrapperRef = node;
        if (node) {
            node.classList.add(this.classToCheck);
        }
    }
    handleClickOutside(e) {
        if (!e.target || !e.target.closest("." + this.classToCheck)) {
            this.props.parent.someOneClickedOutsideMe(this.props.tag);
        }
    }
    render() {
        return React.createElement("div", { ref: this.setWrapperRef }, this.props.children);
    }
}
OutsideClickCheckHandler.counter = 0;
export default OutsideClickCheckHandler;
